import { useState } from 'react';
import { Zap, Copy, Check, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { QRCodeCanvas } from '@/components/ui/qrcode';

const LIGHTNING_ADDRESS = 'simplynostr@wallet.yakihonne.com';
// LNURL / lightning: URI — most wallets accept lightning:user@domain
const LIGHTNING_URI = `lightning:${LIGHTNING_ADDRESS}`;

export function SupportSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(LIGHTNING_ADDRESS);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="border-t border-border/30 py-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="max-w-md mx-auto text-center space-y-6">
          {/* Header */}
          <div className="space-y-2">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/10 border border-yellow-500/20 mb-1">
              <Zap className="w-5 h-5 text-yellow-400" />
            </div>
            <h3 className="text-xl font-bold text-foreground">Support the Show</h3>
            <p className="text-sm text-muted-foreground">
              Enjoying Simply Nostr? Send a zap to keep the conversations going.
            </p>
          </div>

          {/* QR Code */}
          <div className="flex justify-center">
            <div className="p-3 bg-white rounded-2xl shadow-lg shadow-purple-500/10">
              <QRCodeCanvas
                value={LIGHTNING_URI}
                size={180}
                level="M"
                className="rounded-lg"
              />
            </div>
          </div>

          {/* Lightning address + copy */}
          <div className="flex items-center gap-2 bg-muted/40 border border-border/50 rounded-xl px-4 py-3">
            <Zap className="w-4 h-4 text-yellow-400 shrink-0" />
            <span className="flex-1 text-sm font-mono text-foreground truncate text-left">
              {LIGHTNING_ADDRESS}
            </span>
            <button
              onClick={handleCopy}
              className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
              title="Copy lightning address"
            >
              {copied
                ? <Check className="w-4 h-4 text-green-400" />
                : <Copy className="w-4 h-4" />
              }
            </button>
          </div>

          {/* Open in wallet button */}
          <Button
            asChild
            className="w-full rounded-full bg-yellow-500 hover:bg-yellow-400 text-black font-semibold shadow-lg shadow-yellow-500/20"
          >
            <a href={LIGHTNING_URI}>
              <Zap className="w-4 h-4 mr-2" />
              Open in Lightning Wallet
              <ExternalLink className="w-3.5 h-3.5 ml-2 opacity-60" />
            </a>
          </Button>

          <p className="text-xs text-muted-foreground/60">
            Scan the QR code with any Lightning wallet, or tap the button to open your wallet directly.
          </p>
        </div>
      </div>
    </section>
  );
}
